<template>
  <div style="padding:20px">
    <h3>老师：观看学生同屏</h3>
    <video
      ref="remoteVideo"
      autoplay
      playsinline
      muted
      style="width:100%; max-height:480px; border:1px solid #ccc; background:#000;"
    ></video>
    <div style="margin-top:10px">
      连接状态：{{ connState }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      peerConnection: null,
      config: {},
      isAnswer: false,
      webrtcAnswer: "",
      iceCandidates: [],
      connState: "未连接",
      pollTimer: null,
    };
  },

  mounted() {
    this.watchDevices();
  },

  beforeDestroy() {
    this.destroyConnection();
  },

  methods: {
    // ======================
    // 清理连接（老师端专用）
    // ======================
    destroyConnection() {
      console.log("🧹 老师端清理 WebRTC");

      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }

      if (this.peerConnection) {
        try {
          this.peerConnection.close();
        } catch (e) {}
        this.peerConnection = null;
      }

      const video = this.$refs.remoteVideo;
      if (video) {
        video.srcObject = null;
        video.load();
      }

      this.isAnswer = false;
      this.webrtcAnswer = "";
      this.iceCandidates = [];
      this.connState = "已清理";
    },

    // ======================
    // 轮询
    // ======================
    watchDevices() {
      if (this.pollTimer) clearInterval(this.pollTimer);

      this.pollTimer = setInterval(async () => {
        const params = new URLSearchParams();
        params.append("courseClassId", localStorage.getItem('courseClassId'));
        params.append("userId", localStorage.getItem('userId'));
        params.append("userType", "2");
        params.append("nickName", localStorage.getItem('nickName'));
        params.append("webrtcAnswer", this.webrtcAnswer || "");
        params.append("iceCandidates", JSON.stringify(this.iceCandidates) || '');

        try {
          const res = await this.API.post(this.API.fileurl.postLanPeers, params);
          this.checkStudentStream(res.data || []);
        } catch (e) {
          console.error("老师轮询异常", e);
        }
      }, 3000);
    },

    // ======================
    // 检查学生流
    // ======================
    checkStudentStream(data) {
      if (this.isAnswer) return;
      const student = data.find(v => v.userType == 3 && v.toTeacherId);
      if (!student) return;
      if (!student.webrtcOffer) return;

      this.isAnswer = true;
      this.connState = "收到学生Offer";
      this.onStudentOffer(student.webrtcOffer, student.iceCandidates || "[]");
    },

    // ======================
    // 处理学生 Offer（已修复！）
    // ======================
    async onStudentOffer(offerStr, iceStr) {
      try {
        this.peerConnection = new RTCPeerConnection(this.config);
        this.connState = "创建PeerConnection";

        // ICE 收集
        this.peerConnection.onicecandidate = (e) => {
          if (e.candidate) {
            this.iceCandidates.push(e.candidate);
          }
        };

        // 连接状态（✅ 修复：去掉 this.stopShare()）
        this.peerConnection.onconnectionstatechange = () => {
          const state = this.peerConnection.connectionState;
          console.log("🔗 连接状态:", state);
          this.connState = state;

          if (state === 'connected') {
            console.log("🎉 老师端连接成功！");
          }
        };

        // ICE 状态
        this.peerConnection.oniceconnectionstatechange = () => {
          console.log("❄️ ICE 状态:", this.peerConnection.iceConnectionState);
        };

        // ✅ 收到流并播放（修复黑屏关键）
        this.peerConnection.ontrack = (e) => {
          console.log("✅ 老师收到视频流！");
          this.connState = "视频播放中";
          
          this.$nextTick(() => {
            const videoEl = this.$refs.remoteVideo;
            if (!videoEl) return;
            
            videoEl.srcObject = e.streams[0];
            videoEl.play().catch(err => {
              console.warn("自动播放被拦截，点击页面后即可播放", err);
            });
          });
        };

        // 设置远端描述
        const offer = JSON.parse(offerStr);
        await this.peerConnection.setRemoteDescription(offer);

        // 添加 ICE
        const studentIces = JSON.parse(iceStr || "[]");
        for (const ice of studentIces) {
          await this.peerConnection.addIceCandidate(ice);
        }

        // 创建 Answer
        const answer = await this.peerConnection.createAnswer();
        await this.peerConnection.setLocalDescription(answer);
        this.webrtcAnswer = JSON.stringify(answer);
        this.connState = "已发送Answer";

      } catch (err) {
        console.error("老师处理Offer失败", err);
        this.connState = "出错：" + err.message;
      }
    },
  },
};
</script>